export default __webpack_public_path__ + "static/media/Make-a-Donation.41eb0249.png";